export default __webpack_public_path__ + "static/media/c1logo.d0b02c1e.png";